import hoistNonReactStatics from 'hoist-non-react-statics'
import { Table } from '../Table'
import { InfiniteTable as BaseInfiniteTable } from './InfiniteTable'
export type { InfiniteTableProps } from './InfiniteTable'

export const InfiniteTable = hoistNonReactStatics(BaseInfiniteTable, Table)
